<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav">
        <li class="nav-item" v-for="(item, index) in listSideBar">
          <template>
            <SidebarNavIcons :name="item.name" :routerName="item.routerName" :icon="item.icon"></SidebarNavIcons>
          </template>
        </li>
      </ul>
      <div slot="footer"></div>
    </nav>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import SidebarNavIcons from './SidebarNavIcons';
  // import consts from '../../../_consts';
  import routerConstanst from '@/router/constants';

  export default {
    name: 'sidebar',
    data () {
      return {}
    },
    components: {
      SidebarNavIcons
    },
    computed: {
      listSideBar () {
        return [
          {
            name: 'Dashboard',
            routerName: routerConstanst.clientDashboard.children.dashboard.name,
            icon: 'icon-dashboard'
          },
          {
            name: 'Plan',
            routerName: routerConstanst.clientDashboard.children.plan.name,
            icon: 'icon-plan'
          },
          {
            name: 'Manage',
            routerName: routerConstanst.clientDashboard.children.manage.name,
            icon: 'icon-manage'
          },
          {
            name: 'Reports',
            routerName: routerConstanst.clientDashboard.children.reports.name,
            icon: 'icon-report'
          }
        ];
      },
      ...mapGetters({
        countUnreadEventByStatus: 'GETTERS_COUNT_UNREAD_EVENT_BY_STATUS'
      })
    },
    methods: {
      handleClick (e) {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');
      }
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';
  .sidebar {
    background-color: @dark-blue-3;
    .sidebar-nav {
    }
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?70324fd6